module.exports = __webpack_public_path__ + "media/bootstrap-icons/ui-radios-grid-116d48c0.svg";